"use client";
import { ark as t } from "@ark-ui/react";
import { alert as i } from "@huspy/styled-system/recipes";
import { createStyleContext as n } from "../../utils/createStyleContext.mjs";
const { withProvider: r, withContext: e } = n(i), c = r(t.div, "root"), l = e(
  t.div,
  "content"
), s = e(
  t.div,
  "description"
), a = e(
  t.svg,
  "icon"
), p = e(
  t.h5,
  "title"
), o = {
  Root: c,
  Content: l,
  Description: s,
  Icon: a,
  Title: p
};
o.Root.displayName = "AlertRoot";
o.Content.displayName = "AlertContent";
o.Description.displayName = "AlertDescription";
o.Icon.displayName = "AlertIcon";
o.Title.displayName = "AlertTitle";
export {
  o as Alert
};
